// Recovered compiled webpack factory 71702. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  let n;
  r.d(t, { D: () => h, c: () => p });
  var a = r(49636),
    o = r(43275),
    i = r(5424);
  let s = a.O,
    l = null,
    u = new Map(),
    c = new Map();
  function f(e) {
    let t = e.split("/").filter(Boolean),
      r = 0;
    for (let e of t)
      if (e.startsWith(":")) {
        let t = e.substring(1);
        t.endsWith("*?") ? (r += 1e3) : t.endsWith("*") ? (r += 100) : (r += 10);
      }
    return (t.length > 0 && (r += 1 / t.length), r);
  }
  function d(e) {
    if (u.has(e)) return u.get(e) ?? null;
    try {
      let t = new RegExp(e);
      return (u.set(e, t), t);
    } catch (t) {
      return (i.T && o.Yz.warn("Could not compile regex", { regexString: e, error: t }), null);
    }
  }
  function p() {
    if (!s?._sentryRouteManifest || "string" != typeof s._sentryRouteManifest) return null;
    let e = s._sentryRouteManifest;
    if (l && n === e) return l;
    (u.clear(), c.clear());
    let t = { staticRoutes: [], dynamicRoutes: [], isrRoutes: [] };
    try {
      if (((t = JSON.parse(e)), !Array.isArray(t.staticRoutes) || !Array.isArray(t.dynamicRoutes)))
        return null;
      return ((l = t), (n = e), t);
    } catch {
      return (i.T && o.Yz.warn("Could not extract route manifest"), null);
    }
  }
  let h = (e) => {
    let t = p();
    if (!t) return;
    let r = e.length > 1 && e.endsWith("/") ? e.slice(0, -1) : e;
    if (c.has(r)) return c.get(r);
    let { staticRoutes: n, dynamicRoutes: a } = t;
    if (!Array.isArray(n) || !Array.isArray(a)) return;
    let o = (function (e, t, r) {
      let n = [];
      if (t.some((t) => t.path === e)) return n;
      for (let t of r)
        if (t.regex) {
          let r = d(t.regex);
          r?.test(e) && n.push(t.path);
        }
      if (!e.startsWith("/:")) {
        for (let t of r)
          if (t.hasOptionalPrefix && t.regex) {
            let r = "/" === e ? "/SENTRY_OPTIONAL_PREFIX" : `/SENTRY_OPTIONAL_PREFIX${e}`,
              a = d(t.regex);
            a?.test(r) && n.push(t.path);
          }
      }
      return n;
    })(r, n, a).sort((e, t) => f(e) - f(t))[0];
    return (c.set(r, o), o);
  };
}
